import { trackEvent } from '../gtm'
import { showAlert } from "../components/BcAlert";
import { showConfirm } from "../components/BcConfirm";
import { saveAs } from 'file-saver'

export default {
  computed: {
    antivirusState() {
      if (this.file?.virus_found) {
        return 'hasVirus'
      }

      if (!this.file?.antivir_ok && !this.file?.antivir_tested) {
        return 'waiting'
      }

      if (this.file?.antivir_ok && this.file?.antivir_tested) {
        return 'checked'
      }

      return null
    },

    hasPreview() {
      return ((this.file?.previews && this.file?.previews['500x500']) || this.file?.can_generate_preview) && this.antivirusState !== 'hasVirus'
    },
    previewIsLoading() {
      return (!(this.file?.previews && this.file?.previews['500x500']) && this.file?.can_generate_preview) || this.antivirusState === 'waiting'
    },
    isDownloadable() {
      return this.antivirusState !== 'hasVirus' && !this.file?.deleted && this.file?.can_download
    },
    canShowInGallery() {
      return this.antivirusState !== 'hasVirus' && !this.file?.deleted && this.antivirusState !== 'waiting'
        && (this.file?.can_generate_preview || (this.file?.previews && (this.file?.previews['1000x'] || this.file?.previews.viewer || this.file?.previews.video || this.file?.previews.audio)))
    },
    isVideo() {
      return this.file?.previews?.video
    },
    isAudio() {
      return this.file?.previews?.audio
    },
    isFileRequest() {
      return this.file_upload ? true : false
    },
    fileName() {
      return this.isFileRequest ? this.file_upload.name : this.file.name
    },
    fileExt() {
      return this.isFileRequest ? this.file_upload.ext : this.file.ext
    },
    fileSize() {
      return this.isFileRequest ? this.file_upload.size : this.file.size
    },
    fileUploaded() {
      return this.isFileRequest ? this.file_upload.upload_start : this.file.uploaded
    }
  },
  methods: {
    async avCheck() {
      if (this.file?.virus_found) {
        await showAlert({
          header: this.$t('Cannot download virus infected file.'),
        })
        return false
      }

      if (!this.file?.antivir_ok && !this.file?.antivir_tested) {
        return await showConfirm({
          header: this.$t('Do you really want to download antivir untested file?'),
          text: this.$t('Selected file haven\'t been tested with antivirus yet.'),
        })
      }

      return true
    },
    async downloadFile() {
      if (!await this.avCheck()) {
        return
      }

      saveAs(this.file?.download_url.original)
      trackEvent(this.$route.matched[0].name, 'downloadFile', this.file?.id)
    },
  }
}